/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Jul 20th 2021, 2:37:44 pm
 *
 * *****************************************************
 */

import { createGlobalStyle } from 'styled-components';

import colors from 'constants/colors';
import texts from 'constants/texts';

const GlobalStyle = createGlobalStyle`
  /* MAIN CSS */

  html, body {
    box-sizing: border-box;
    width: 100%;
    font-size: 62.5%;
  }

  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: 0 !important;
    ${texts.body['Body 1 - 14px - R']}
    background-color: ${colors.primary.surface}
  }

  /* OVERRIDEN CSS */
  #wise {
    /* Color variables */

    // Primary
    --p-action-primary: ${colors.primary.action};
    --p-action-primary-hovered: ${colors.primary.actionHovered};
    --p-action-primary-pressed: ${colors.primary.actionPressed};
    --p-action-primary-depressed: ${colors.primary.actionDepressed};
    // OnSurface
    --p-text-subdued: ${colors.onSurface.textSubddued};
    --p-divider: ${colors.onSurface.divider};
    // Interactive
    --p-interactive: ${colors.interactive.default};
    --p-interactive-hovered: ${colors.interactive.hovered};
    // --p-focused: ${colors.interactive.focused};
    // Secondary
    // --p-action-secondary-hovered: ${colors.secondary.actionHovered};
    // Overrides
    --p-border-critical-subdued: ${colors.overrides.bannerBorderCritical};


    /* Text style variables */
    --p-button-font-weight: 600;
  }

  html, body, button{
    font-family: SF Pro Text;
  }

  .Polaris-Button {
    padding: 1.2rem 1.6rem;
  }

  .Polaris-TextField__Input {
    padding: 0.8rem 1.2rem;
  }
`;

export default GlobalStyle;
